var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListAltAdd = function SvgListAltAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e8eaed",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M680-40v-120H560v-80h120v-120h80v120h120v80H760v120zM200-200v-560zm0 80q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v353q-18-11-38-18t-42-11v-324H200v560h280q0 21 3 41t10 39zm120-160q17 0 28.5-11.5T360-320t-11.5-28.5T320-360t-28.5 11.5T280-320t11.5 28.5T320-280m0-160q17 0 28.5-11.5T360-480t-11.5-28.5T320-520t-28.5 11.5T280-480t11.5 28.5T320-440m0-160q17 0 28.5-11.5T360-640t-11.5-28.5T320-680t-28.5 11.5T280-640t11.5 28.5T320-600m120 160h240v-80H440zm0-160h240v-80H440zm0 320h54q8-23 20-43t28-37H440z"
  })));
};
export default SvgListAltAdd;